// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
} from 'firebase/functions';

// ===== Interfaces =====

import {
    IUpdatePostResult,
} from '../interfaces';

const updatePostScopeAccessMetadata = async ({
    test,
    docId,
    paywalled,
    authLocked,
    lockedUntil,
}: {
    test: boolean,
    docId: string,
    paywalled: boolean | null,
    authLocked: boolean | null,
    lockedUntil: number | null,
}): Promise<IUpdatePostResult> => {
    const functions = getFunctions();
    const handleUpdate = httpsCallable<
        Record<string, boolean | number | string | null>,
        IUpdatePostResult
    >(
        functions,
        'updatePostScopeAccessMetadata',
    );
    const result = await handleUpdate({
        test,
        docId,
        paywalled,
        authLocked,
        lockedUntil,
    });
    return result.data as IUpdatePostResult;
};

export default updatePostScopeAccessMetadata;
